import { ErrorResponse, RequestOptions } from "@/types/commonTypes"
import { getSubdomain } from "@/utilities/domain"

const subdomain = getSubdomain()

export const defaultHeadersWeb = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Tenant": subdomain,
  Authorization: `Bearer ${
    typeof window !== "undefined" && localStorage.getItem("website_token")
      ? localStorage.getItem("website_token")
      : ""
  }`,
})

export const apiFetchWeb = async <R>(
  url: string,
  options: RequestOptions = {},
  handleValidationError?: (data: ErrorResponse) => void
) => {
  // Check if body is FormData - if so, don't set Content-Type header
  const isFormData = options.body instanceof FormData

  if (!isFormData) {
    options.headers = {
      ...defaultHeadersWeb(),
      ...options.headers,
    }
  } else {
    // For FormData, only set Authorization header
    // DO NOT set Content-Type - browser will set it automatically with boundary
    options.headers = {
      Authorization: `Bearer ${
        typeof window !== "undefined" && localStorage.getItem("website_token")
          ? localStorage.getItem("website_token")
          : ""
      }`,
      // Don't spread other headers that might include Content-Type
      ...(options.headers &&
        Object.fromEntries(
          Object.entries(options.headers).filter(
            ([key]) => key.toLowerCase() !== "content-type"
          )
        )),
    }
  }

  const response = await fetch(
    `${import.meta.env.VITE_BASE_URL}/${url}`,
    options
  )

  const contentType = response.headers.get("Content-Type")
  const isJson = contentType && contentType.includes("application/json")
  const data = isJson ? await response.json() : null

  if (!response.ok) {
    if (
      response.status === 422 &&
      typeof handleValidationError === "function"
    ) {
      handleValidationError(data)
    }

    throw data
    throw new Error(data?.message || "Something went wrong")
  }

  if (!isJson) {
    throw new Error("Invalid response format")
  }

  return data as R
}
